<template>
  <g>
    <path
      d="M12 8.50018C11.09 8.50018 9.25 8.96018 9.25 9.88018V14.0002C9.25 14.2802 9.47 14.5002 9.75 14.5002H10.75V17.7502C10.75 18.4402 11.31 19.0002 12 19.0002C12.69 19.0002 13.25 18.4402 13.25 17.7502V14.5002H14.25C14.53 14.5002 14.75 14.2802 14.75 14.0002V9.88018C14.75 8.97018 12.91 8.50018 12 8.50018ZM12 2.00018C6.47 2.00018 2 6.47018 2 12.0002C2 17.5302 6.47 22.0002 12 22.0002C17.53 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM12 20.0002C7.58 20.0002 4 16.4202 4 12.0002C4 7.58018 7.58 4.00018 12 4.00018C16.42 4.00018 20 7.58018 20 12.0002C20 16.4202 16.42 20.0002 12 20.0002Z"
    />
    <path
      d="M12 8.00018C12.8284 8.00018 13.5 7.32861 13.5 6.50018C13.5 5.67176 12.8284 5.00018 12 5.00018C11.1716 5.00018 10.5 5.67176 10.5 6.50018C10.5 7.32861 11.1716 8.00018 12 8.00018Z"
    />
  </g>
</template>
